import { render } from "./application-logo.vue?vue&type=template&id=67780d7f"
import script from "./application-logo.vue?vue&type=script&lang=js"
export * from "./application-logo.vue?vue&type=script&lang=js"

import exportComponent from "/home/aaicom7/repositories/AAI-FMS/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__